// Per-conversation translation preferences stored in localStorage.
// Shape: { inboundOn, outboundPreviewOn, outboundAutoTranslate, peerLang }
// peerLang is ONLY for outbound draft preview (target language for the peer).
// Bubble auto-translate (inbound + outbound) always targets SELF_LANGUAGE and
// auto-detects source — it must never read peerLang.
const STORAGE_PREFIX = 'translation_settings';

export const DEFAULT_PREFS = Object.freeze({
  inboundOn: false,
  outboundPreviewOn: false,
  outboundAutoTranslate: false,
  peerLang: 'en',
});

export const PEER_LANGUAGE_CODES = Object.freeze([
  'en',
  'es',
  'fr',
  'pt',
  'ar',
  'ja',
  'ko',
]);

export const SELF_LANGUAGE = 'zh-CN';

/** Sentinel stored when the model reports source is already the target language. */
export const SAME_LANG_SENTINEL = '<same_lang/>';

const SAME_LANG_PATTERN = /^\s*<\/?same_lang\s*\/?>\s*$/i;

export const isSameLangMarker = value => SAME_LANG_PATTERN.test(String(value || ''));

const buildKey = (accountId, conversationId) =>
  `${STORAGE_PREFIX}:${accountId}:${conversationId}`;

export const loadPrefs = (accountId, conversationId) => {
  try {
    const raw = window.localStorage.getItem(
      buildKey(accountId, conversationId)
    );
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch (err) {
    return { ...DEFAULT_PREFS };
  }
};

export const savePrefs = (accountId, conversationId, prefs) => {
  try {
    window.localStorage.setItem(
      buildKey(accountId, conversationId),
      JSON.stringify(prefs)
    );
  } catch (err) {
    // localStorage may be disabled or quota exceeded; fail silently.
  }
};
